import React, { useEffect, useState } from "react";
import { cases as casesApi, users as usersApi } from "../../api/endpoints";
import { useAuth } from "../../auth/AuthContext";
import Spinner from "../../components/Spinner";
import Empty from "../../components/Empty";
import Confirm from "../../components/Confirm";
import { TipoPill, EstadoPill } from "../../components/Pills";
import { useToast } from "../../components/Toast";
import CaseDetail from "../case-detail";

function daysWaiting(c) {
  return Math.floor((Date.now() - new Date(c.fecha_ingreso).getTime()) / 86400000);
}

export default function TeamQueue() {
  const { user } = useAuth();
  const toast = useToast();
  const [data, setData] = useState(null);
  const [usersMap, setUsersMap] = useState({});
  const [openId, setOpenId] = useState(null);
  const [claimTarget, setClaimTarget] = useState(null);

  function load() {
    setData(null);
    casesApi.list({ estado: "pendiente_insumos" })
      .then(r => setData(r.data.sort((a, b) => new Date(a.fecha_ingreso) - new Date(b.fecha_ingreso))))
      .catch(() => setData([]));
  }

  useEffect(() => {
    load();
    usersApi.list().then(r => {
      const m = {};
      for (const u of r.data) m[u.id] = u;
      setUsersMap(m);
    });
  }, []);

  async function doClaim() {
    const c = claimTarget;
    if (!c) return;
    try {
      await casesApi.action(c.id, "claim_insumo");
      toast.push(`Caso ${c.case_number} reclamado. Ahora aparece en su cola.`);
      setClaimTarget(null);
      load();
    } catch (e) {
      toast.push(e?.response?.data?.error || "Error al reclamar", "error");
    }
  }

  return (
    <div className="col" style={{ gap: 16 }}>
      <h1 style={{ margin: 0 }}>Cola del equipo</h1>
      <div className="muted" style={{ marginTop: -8 }}>Todos los casos pendientes de insumos. Puede reclamar uno de otra persona si es necesario.</div>

      <div className="card" style={{ padding: 0 }}>
        {data == null ? (
          <div style={{ padding: 32, textAlign: "center" }}><Spinner size={20} /></div>
        ) : !data.length ? (
          <Empty title="Cola vacía" message="No hay casos pendientes de insumos en este momento." />
        ) : (
          <table>
            <thead>
              <tr>
                <th>Caso</th><th>Tipo de actuación</th><th>Accionante</th><th>Radicado</th>
                <th>Asignado a</th><th>Días en trámite</th><th>Estado de la actuación</th><th></th>
              </tr>
            </thead>
            <tbody>
              {data.map(c => {
                const isMine = c.assigned_insumos_id === user.id;
                const assignee = c.assigned_insumos_id ? usersMap[c.assigned_insumos_id]?.name || `#${c.assigned_insumos_id}` : "—";
                return (
                  <tr key={c.id} style={{ cursor: "pointer" }}>
                    <td onClick={() => setOpenId(c.id)}><strong>{c.case_number}</strong></td>
                    <td onClick={() => setOpenId(c.id)}><TipoPill tipo={c.tipo} /></td>
                    <td onClick={() => setOpenId(c.id)}>{c.accionante_nombre || "—"}</td>
                    <td onClick={() => setOpenId(c.id)}>{c.radicado}</td>
                    <td onClick={() => setOpenId(c.id)}>{isMine ? <span className="badge mint">Yo</span> : assignee}</td>
                    <td onClick={() => setOpenId(c.id)}>{daysWaiting(c)}</td>
                    <td onClick={() => setOpenId(c.id)}><EstadoPill c={c} /></td>
                    <td>
                      {!isMine && (
                        <button className="secondary sm" onClick={(e) => { e.stopPropagation(); setClaimTarget(c); }}>
                          Reclamar
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      <Confirm
        open={!!claimTarget}
        title="Reclamar caso"
        message={claimTarget
          ? `¿Tomar el caso ${claimTarget.case_number} de ${usersMap[claimTarget.assigned_insumos_id]?.name || "el equipo"}? La persona original recibirá una notificación.`
          : ""}
        onClose={() => setClaimTarget(null)}
        onConfirm={doClaim}
        confirmText="Reclamar"
      />

      <CaseDetail caseId={openId} open={!!openId} defaultTab="insumos" onClose={() => setOpenId(null)} onChanged={load} />
    </div>
  );
}
